import { size } from "lodash";
import { Dispatch, SetStateAction } from "react";
import { Modal } from "react-bootstrap";

export type TAlertInfoProps = {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  backdrop?: boolean | "static";
  keyboard?: boolean;
  title?: string | JSX.Element | JSX.Element[];
  description?: string | JSX.Element | JSX.Element[];
  size?: "sm" | "lg" | "xl";
  onClose?: () => void;
};

AlertInfo.defaultProps = {
  show: false,
  setShow: () => {},
  backdrop: "static",
  keyboard: false,
  title: "Information",
  description: "Details...",
  size: "lg",
  onClose: () => {},
};

export default function AlertInfo(props: TAlertInfoProps) {
  return (
    <Modal
      className="modal-generic alert-info"
      show={props.show}
      backdrop={props.backdrop}
      keyboard={props.keyboard}
      onHide={() => {
        props.setShow(false);
        props.onClose?.();
      }}
      size={props.size}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title ?? "Information"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="mb-4">{props.description ?? "No details available."}</Modal.Body>
    </Modal>
  );
}
